import styled from 'styled-components'
import Icon24 from 'builder/components/Icon'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'

export const PanelContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`

export const PanelItem = styled.div``

export const PanelHeader = styled.div`
  cursor: pointer;
  font-weight: bold;
  margin: 4px 0;
`

interface PanelContentProps {
  isOpen: boolean
}

export const PanelContentWrapper = styled.div<PanelContentProps>`
  display: ${({ isOpen }) => (isOpen ? 'grid' : 'none')};
  gap: 4px;
`

export const SectionContainer = styled.div`
  background-color: ${Colors.White};
  padding: 32px;
  border-radius: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 86px;
  ${Media.Tablet`
    padding: 24px;
    gap: 64px;
  `}
  ${Media.Phone`
    padding: 16px;
    gap: 24px;
  `}
`

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const InvalidFeedback = styled.div`
  background-color: ${Colors.Blue10};
  padding: 32px;
  border-radius: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 86px;
  ${Media.Tablet`
    padding: 24px;
    gap: 64px;
  `}
  ${Media.Phone`
    padding: 16px;
    gap: 24px;
  `}
`

export const ToggleSectionIcon = styled(Icon24.Chevron)<{ $isOpen?: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  color: #828ba2;
  width: 32px;
  height: 28px;
  flex-shrink: 0;
`

export const InvalidFeedbackLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
